import React from "react"
import ReactDOM from "react-dom"
import "./styles/App.css"
import App from "./components/App"
import registerServiceWorker from "./registerServiceWorker"
import WebFontLoader from "webfontloader"

WebFontLoader.load({
	google: {
		families: ["Roboto:300,400,500,700", "Material Icons", "Libre Baskerville:400,400i,700"]
	}
})

ReactDOM.render(<App/>, document.getElementById("root"))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js